import { find, every } from 'lodash';
import { MODELS } from '../admin/settings';

export const ROLE_NONE = 'NONE';
export const ROLE_ARTIST_USER = 'ARTIST_USER';
export const ROLE_PARTNER_USER = 'PARTNER_USER';
export const ROLE_SUPER_ORGANIZATION_USER = 'SUPER_ORGANIZATION_ADMIN';
export const ROLE_ORGANIZATION_USER = 'ORGANIZATION_ADMIN';
export const ROLE_GOD_USER = 'GOD';

export const ROLE_TYPE_ORGANIZATION = 'organization';
export const ROLE_TYPE_PARTNER = 'partner';
export const ROLE_TYPE_ARTIST = 'artist';

export const PERMISSIONS = {
    GOD: 'CLR_ALL',
    VIEW_LINEUP: 'CLR_VIEW_LINEUP',

    VIEW_CONTRACTS_INBOX: 'CLR_VIEW_CONTRACTS_INBOX',
    VIEW_SIGNED_CONTRACTS_INBOX: 'CLR_VIEW_SIGNED_CONTRACTS_INBOX',
    SIGN_CONTRACTS_INBOX: 'CLR_SIGN_CONTRACTS_INBOX',
    COMMENT_CONTRACTS_INBOX: 'CLR_COMMENT_CONTRACTS_INBOX',

    ACCESS_ADMIN: 'CLR_ACCESS_ADMIN',

    ORGANIZATIONS_VIEW_ALL: 'CLR_ORGANIZATIONS_VIEW_ALL',
    ARTISTS_VIEW_ALL: 'CLR_ARTISTS_VIEW_ALL',
    PARTNERS_VIEW_ALL: 'CLR_PARTNERS_VIEW_ALL',
    CONTACTS_VIEW_ALL: 'CLR_CONTACTS_VIEW_ALL',

    [`${MODELS.EVENT.toUpperCase()}S_VIEW`]: 'CLR_EVENTS_VIEW',
    [`${MODELS.EVENT.toUpperCase()}S_DELETE`]: 'CLR_EVENTS_DELETE',
    [`${MODELS.EVENT.toUpperCase()}_ADD`]: 'CLR_EVENTS_ADD',
    [`${MODELS.EVENT.toUpperCase()}_EDIT`]: 'CLR_EVENTS_EDIT',

    [`${MODELS.ARTIST_CONTACTS.toUpperCase()}S_VIEW`]: 'CLR_EVENTS_VIEW',
    [`${MODELS.ARTIST_CONTACTS.toUpperCase()}S_DELETE`]: 'CLR_EVENTS_DELETE',
    [`${MODELS.ARTIST_CONTACTS.toUpperCase()}_ADD`]: 'CLR_EVENTS_ADD',
    [`${MODELS.ARTIST_CONTACTS.toUpperCase()}_EDIT`]: 'CLR_EVENTS_EDIT',

    [`${MODELS.ARTIST.toUpperCase()}S_VIEW`]: 'CLR_ARTISTS_VIEW',
    [`${MODELS.ARTIST.toUpperCase()}S_DELETE`]: 'CLR_ARTISTS_DELETE',
    [`${MODELS.ARTIST.toUpperCase()}_ADD`]: 'CLR_ARTISTS_ADD',
    [`${MODELS.ARTIST.toUpperCase()}_EDIT`]: 'CLR_ARTISTS_EDIT',

    [`${MODELS.CONTACT.toUpperCase()}S_VIEW`]: 'CLR_CONTACTS_VIEW',
    [`${MODELS.CONTACT.toUpperCase()}S_DELETE`]: 'CLR_CONTACTS_DELETE',
    [`${MODELS.CONTACT.toUpperCase()}_ADD`]: 'CLR_CONTACTS_ADD',
    [`${MODELS.CONTACT.toUpperCase()}_EDIT`]: 'CLR_CONTACTS_EDIT',

    [`${MODELS.PARTNER.toUpperCase()}S_VIEW`]: 'CLR_PARTNERS_VIEW',
    [`${MODELS.PARTNER.toUpperCase()}S_DELETE`]: 'CLR_PARTNERS_DELETE',
    [`${MODELS.PARTNER.toUpperCase()}_ADD`]: 'CLR_PARTNERS_ADD',
    [`${MODELS.PARTNER.toUpperCase()}_EDIT`]: 'CLR_PARTNERS_EDIT',

    [`${MODELS.CONTRACT.toUpperCase()}S_VIEW`]: 'CLR_CONTRACTS_VIEW',
    [`${MODELS.CONTRACT.toUpperCase()}S_DELETE`]: 'CLR_CONTRACTS_DELETE',
    [`${MODELS.CONTRACT.toUpperCase()}_ADD`]: 'CLR_CONTRACTS_ADD',
    [`${MODELS.CONTRACT.toUpperCase()}_EDIT`]: 'CLR_CONTRACTS_EDIT',

    [`${MODELS.TEMPLATE.toUpperCase()}S_VIEW`]: 'CLR_CONTRACTS_VIEW',
    [`${MODELS.TEMPLATE.toUpperCase()}S_DELETE`]: 'CLR_CONTRACTS_DELETE',
    [`${MODELS.TEMPLATE.toUpperCase()}_ADD`]: 'CLR_CONTRACTS_ADD',
    [`${MODELS.TEMPLATE.toUpperCase()}_EDIT`]: 'CLR_CONTRACTS_EDIT',

    [`${MODELS.PERMISSION.toUpperCase()}S_VIEW`]: 'CLR_PERMISSIONS_VIEW',
    [`${MODELS.PERMISSION.toUpperCase()}S_DELETE`]: 'CLR_PERMISSIONS_DELETE',
    [`${MODELS.PERMISSION.toUpperCase()}_ADD`]: 'CLR_PERMISSIONS_ADD',
    [`${MODELS.PERMISSION.toUpperCase()}_EDIT`]: 'CLR_PERMISSIONS_EDIT',

    [`${MODELS.CONTRACT_PARTNER.toUpperCase()}S_VIEW`]: 'CLR_CONTRACTS_VIEW',
    [`${MODELS.CONTRACT_PARTNER.toUpperCase()}S_DELETE`]: 'CLR_CONTRACTS_DELETE',
    [`${MODELS.CONTRACT_PARTNER.toUpperCase()}_ADD`]: 'CLR_CONTRACTS_ADD',
    [`${MODELS.CONTRACT_PARTNER.toUpperCase()}_EDIT`]: 'CLR_CONTRACTS_EDIT',

    [`${MODELS.EVENT_PARTNER.toUpperCase()}S_VIEW`]: 'CLR_EVENTS_VIEW',
    [`${MODELS.EVENT_PARTNER.toUpperCase()}S_DELETE`]: 'CLR_EVENTS_DELETE',
    [`${MODELS.EVENT_PARTNER.toUpperCase()}_ADD`]: 'CLR_EVENTS_ADD',
    [`${MODELS.EVENT_PARTNER.toUpperCase()}_EDIT`]: 'CLR_EVENTS_EDIT',

    [`${MODELS.EVENT_EMAIL_SENDER.toUpperCase()}_ADD`]: 'CLR_EVENTS_ADD',
    [`${MODELS.EVENT_EMAIL_SENDER.toUpperCase()}S_DELETE`]: 'CLR_EVENTS_DELETE',
    [`${MODELS.EVENT_EMAIL_SENDER.toUpperCase()}S_VIEW`]: 'CLR_EVENTS_VIEW',

    [`${MODELS.EVENT_REMINDER.toUpperCase()}S_VIEW`]: 'CLR_EVENTS_VIEW',
    [`${MODELS.EVENT_REMINDER.toUpperCase()}S_DELETE`]: 'CLR_EVENTS_EDIT',
    [`${MODELS.EVENT_REMINDER.toUpperCase()}_ADD`]: 'CLR_EVENTS_ADD',
    [`${MODELS.EVENT_REMINDER.toUpperCase()}_EDIT`]: 'CLR_EVENTS_EDIT'
};

export const ALL_EVENTS_PERMISSIONS_OPTION = {
    notFor: [ROLE_ARTIST_USER, ROLE_PARTNER_USER],
    value: -1,
    label: 'All events'
};

export const hasPermissions = (user, ...permissions) => {
    return (
        user &&
        !!(
            find(user.permissions, p => p === PERMISSIONS.GOD) ||
            every(
                permissions,
                p => (user.contextRole.id ? user.contextRole.permissions : user.permissions).indexOf(p) >= 0
            )
        )
    );
};

export const hasViewAllPermission = user => {
    return (
        user &&
        (find(user.permissions, p => p === PERMISSIONS.ARTISTS_VIEW_ALL) ||
            find(user.permissions, p => p === PERMISSIONS.PARTNERS_VIEW_ALL) ||
            find(user.permissions, p => p === PERMISSIONS.CONTACTS_VIEW_ALL))
    );
};

export function ifPermission(user, permission, doThis, elseThis = null) {
    if (hasPermissions(user, permission)) {
        return doThis;
    } else {
        return elseThis;
    }
}



// WEBPACK FOOTER //
// ./src/constants/authentication/permissions.js